import PrintReceipt from './PrintReceipt';

export default PrintReceipt;
